import { TabHistory } from './tab.types';

/** LAN IP 등 비보안 컨텍스트(http)에서는 randomUUID가 없을 수 있음 — getRandomValues 폴백 */
function randomUUIDv4InBrowser(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function generateTabId(): string {
  let uuid: string;

  if (typeof window !== 'undefined') {
    uuid = randomUUIDv4InBrowser();
  } else {
    const { randomUUID } = require('crypto');
    uuid = randomUUID();
  }

  const uuidWithoutHyphens = uuid.replace(/-/g, '');
  const binary = Buffer.from(uuidWithoutHyphens, 'hex');
  const base64 = binary.toString('base64');

  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export const TAB_HISTORY_START_CURSOR = 0;

export function truncateHistoriesAfterCursor(
  histories: TabHistory[],
  cursor: number
): TabHistory[] {
  return cursor < histories.length - 1 ? histories.slice(0, cursor + 1) : histories;
}

export function limitHistories(histories: TabHistory[], maxCount: number): TabHistory[] {
  return histories.length > maxCount ? histories.slice(-maxCount) : histories;
}
